module.exports = __webpack_public_path__ + "img/public-liability (1).6413e6f.svg";